import OrganizationProgramNew from 'src/components/Organization/pages/programs/new';

export default OrganizationProgramNew;
